// src/components/Steps/TeamIndexStep.js
import React from 'react';
import TeamIndex from '../TeamIndex';

export default function TeamIndexStep({
  teamIndexList,
  setEditingTeam,
  setEditingRange,
  setStep,
  competition,
  setTeamMembers,
  setTeamName,
  selectedDate,
  step,
  setEditingTeamId,
  setTeam
}) {
  return (
    <TeamIndex
      teamIndexList={teamIndexList}
      setEditingTeam={setEditingTeam}
      setEditingRange={setEditingRange}
      setStep={setStep}
      competition={competition}
      setTeamMembers={setTeamMembers}
      setTeamName={setTeamName}
      selectedDate={selectedDate}
      step={step}
      setTeam={setTeam}
      competitionEvent={selectedDate}
      setEditingTeamId={setEditingTeamId}
    />
  );
}
